// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerFilledSvg from "@fishx/icons-svg/es/asn/ContainerFilled";
import FishxIcon from '../components/FishxIcon';

var ContainerFilled = function ContainerFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerFilledSvg
  }));
};

ContainerFilled.displayName = 'ContainerFilled';
export default React.forwardRef(ContainerFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContainerFilled.js
// module id = 2316
// module chunks = 0